<template>
    <div class="info_set_wrap" :style="`height: ${windowHeight - 20}px;`">
        <div class="info_set_box" :style="`min-height: ${windowHeight - 60}px;`">
            <div class="mini_title">您好，非常感谢您安装“微校+”套件，请完成个人信息的设置</div>
            <div class="info_set_content">
                <div class="form_title">设置账号信息</div>
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="学校名称">
                        <span>{{infoSetJson.schoolName || ''}}</span>
                    </el-form-item>
                    <el-form-item label="联系人" prop="name">
                        <el-input v-model.trim="formData.name" :minlength="1" :maxlength="5"
                                  placeholder="请输入联系人"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="mobile">
                        <el-input v-model.trim="formData.mobile" :maxlength="11" placeholder="11位有效手机号"
                                  autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="formData.email" placeholder="请输入邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="经销商编号" prop="bussinessNumber">
                        <el-input v-model.trim="formData.bussinessNumber" :minlength="1" :maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="学校类型" prop="schoolType">
                        <el-radio-group v-model="formData.schoolType" style="line-height: 24px;" @change="changeType">
                            <el-radio :label="1">幼儿园</el-radio>
                            <el-radio :label="2">小学</el-radio>
                            <el-radio :label="3">初中</el-radio>
                            <el-radio :label="4">高中</el-radio>
                            <el-radio :label="5">教育局</el-radio>
                            <el-radio :label="6">六年制</el-radio>
                            <el-radio :label="9">九年制</el-radio>
                            <el-radio :label="12">十二年制</el-radio>
                            <el-radio :label="7">大中专</el-radio>
                            <el-radio :label="10">特殊教育</el-radio>
                            <el-radio :label="20">企业</el-radio>
                            <el-radio :label="30">校外机构</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="区编码" prop="areaCode" v-if="formData.schoolType === 5">
                        <location-selector v-model="locationArray" :hasDistAll="false"
                                           ref="locationSelector"></location-selector>
                    </el-form-item>
                </el-form>

                <div class="update_info_box">
                    <el-button type="primary" size="medium" @click="saveInfo">提 交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LocationSelector from '@/components/LocationSelector';
    import windowResize from '@/mixins/windowResize'
    import {getAdminInfo, doAdminUserRegist} from '@/api/infoSet'

    export default {
        name: "infoSetIndex",
        components: {LocationSelector},
        data() {
            const checkMobile = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空！'));
                }
                const g = /^0?1[345789][0-9]\d{8}$/;
                if (!g.test(value)) {
                    callback(new Error('手机号码格式不正确！'));
                } else {
                    callback();
                }
            };
            return {
                id: this.$route.query.id,
                suiteId: '',
                infoSetJson: {},
                locationArray: ['320000', '320100', '320102'],
                formData: {
                    name: '',
                    mobile: '',
                    email: '',
                    bussinessNumber: '',
                    schoolType: '',
                    areaCode: 123
                },
                rules: {
                    name: [
                        {required: true, trigger: 'blur', message: '请输入联系人'},
                        {min: 1, max: 5, message: "输入长度在1到5个字符", trigger: "change"}
                    ],
                    mobile: [
                        {required: true, validator: checkMobile, trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
                    ],
                    areaCode: [
                        {required: true, message: '请输入区编码'}
                    ]
                }
            }
        },
        mixins: [windowResize],
        created() {
            document.title = '注册';
            this.getAdminInfo();
        },
        methods: {
            changeType() {
                this.locationArray = ['320000', '320100', '320102'];
            },
            getAdminInfo() {
                getAdminInfo({
                    id: this.id
                }).then(data => {
                    this.infoSetJson = data;
                    this.formData.name = data.name || '';
                    this.formData.mobile = data.mobile || '';
                    this.formData.email = data.email || '';
                    this.formData.schoolType = data.schoolType || '';
                    this.suiteId = data.suiteId;
                }).catch(err => {
                })
            },
            saveInfo() {
                this.$refs.form.validate(isValid => {
                    if (isValid) {
                        new Promise(resolve => {
                            let query = {
                                id: this.id,
                                age: this.infoSetJson.age || 0,
                                gender: this.infoSetJson.gender || 0,
                                suiteId: this.suiteId
                            };
                            query.areaCode = this.locationArray[2] == '0' ? (this.locationArray[1] == '0' ? (this.locationArray[0] == '' ? '' : this.locationArray[0]) : this.locationArray[1]) : this.locationArray[2];
                            doAdminUserRegist(Object.assign(this.formData, query)).then(resolve)
                        }).then(() => {
                            this.$message.success('注册成功');
                            this.$router.replace('/main/developmentSystem/suiteSystem/suiteManage/suiteManageIndex');
                        }).catch(res => {
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../styles/mixin';

    .info_set_wrap {
        padding: 20px 0;
        background: #e9eaeb;
        @include scrollBar;

        .info_set_box {
            width: 1080px;
            margin: 0 auto;
            padding-top: 20px;
            background: #fff;
            overflow: hidden;
            border-radius: 5px;

            .mini_title {
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 14px;
                color: #666;
            }

            .info_set_content {
                width: 810px;
                margin: 10px auto;

                .form_title {
                    font-weight: bold;
                    margin-bottom: 10px;
                    padding-left: 30px;
                }

                .update_info_box {
                    padding-top: 20px;
                    text-align: center;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/infoSetIndex.vue